const basePath = 'workspace/system'
export const ROUTER_WORKSPACE_SYSTEM = {
	setting: `/${basePath}/setting`,
	onboarding: `/${basePath}/onboarding`,
	create_workspace: `/${basePath}/create-workspace`,
	policy: `/${basePath}/policy`
}

export const TRANSLATE_WORKSPACE_SYSTEM_SETTING = `${basePath}`
